import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'section2',
    templateUrl: './section2.html',
    styleUrls: ['./section2.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class Section2Component {
    @Input()
    sectionIcon = '';

    @Input()
    sectionTitle = '';

    @Input()
    sectionSubtitle = '';

    @Input()
    sectionCta = 'View';

    @Input()
    sectionCtaLink = '';
}
